import React, { useState } from "react";
import { Checkbox, TextField } from "@material-ui/core";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";

import { alternarTodos } from "../../helpers/itensLead";

// As listas com filtro da aba Itens do ERP (selectOneMenu / selectCheckboxMenu com filter="true",
// filterMatchMode="contains"): busca por qualquer trecho, sem diferenciar maiúscula nem acento.

const TEXTOS = { noOptionsText: "Nenhum resultado", openText: "Abrir", closeText: "Fechar", clearText: "Limpar" };
const LISTA = { style: { maxHeight: 300 } };
const TODOS = { id: "__todos__" };

const rotuloPadrao = (o) => (o && o.nome) || "";

export const SelecaoBusca = ({ opcoes, valor, onChange, placeholder, disabled, className, rotulo = rotuloPadrao }) => {
	const selecionada = (opcoes || []).find((o) => o.id === valor) || null;
	return (
		<Autocomplete
			{...TEXTOS}
			size="small"
			className={className}
			options={opcoes || []}
			value={selecionada}
			disabled={disabled}
			ListboxProps={LISTA}
			getOptionLabel={rotulo}
			getOptionSelected={(o, v) => o.id === v.id}
			onChange={(e, o) => onChange(o ? o.id : null)}
			renderInput={(params) => <TextField {...params} variant="outlined" placeholder={placeholder} />}
		/>
	);
};

export const SelecaoMultiplaBusca = ({ opcoes, valores, onChange, placeholder, disabled, className, rotulo = rotuloPadrao }) => {
	const [texto, setTexto] = useState("");
	const filtrar = createFilterOptions({ stringify: rotulo });
	const visiveis = filtrar(opcoes || [], { inputValue: texto, getOptionLabel: rotulo });
	const todosMarcados = visiveis.length > 0 && visiveis.every((o) => valores.includes(o.id));
	const selecionadas = (opcoes || []).filter((o) => valores.includes(o.id));

	// "Marcar todos" é a primeira opção da lista: clicar nela entra no value, e aí vira alternar os visíveis.
	const mudar = (e, novas) => {
		if (novas.some((o) => o.id === TODOS.id)) {
			onChange(alternarTodos(valores, visiveis.map((o) => o.id)));
			return;
		}
		onChange(novas.map((o) => o.id));
	};

	return (
		<Autocomplete
			{...TEXTOS}
			multiple
			disableCloseOnSelect
			size="small"
			className={className}
			options={[TODOS, ...(opcoes || [])]}
			value={selecionadas}
			disabled={disabled}
			ListboxProps={LISTA}
			inputValue={texto}
			onInputChange={(e, v, motivo) => motivo !== "reset" && setTexto(v)}
			filterOptions={() => (visiveis.length ? [TODOS, ...visiveis] : [])}
			getOptionLabel={(o) => (o.id === TODOS.id ? "Marcar todos" : rotulo(o))}
			getOptionSelected={(o, v) => o.id === v.id}
			onChange={mudar}
			renderTags={(sel) => (sel.length ? <span style={{ marginLeft: 6, fontSize: 13 }}>{sel.length} selecionado(s)</span> : null)}
			renderOption={(o, { selected }) => (
				<>
					<Checkbox size="small" color="primary" style={{ marginRight: 6, padding: 2 }}
						checked={o.id === TODOS.id ? todosMarcados : selected} />
					{o.id === TODOS.id ? <b>Marcar todos{texto ? " (filtrados)" : ""}</b> : rotulo(o)}
				</>
			)}
			renderInput={(params) => (
				<TextField {...params} variant="outlined" placeholder={valores.length ? "" : placeholder} />
			)}
		/>
	);
};
